export default __webpack_public_path__ + "52a6437b3cbaec0fca75aba330e2e46b.svg";